/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Go_To_Next_TitleInputs */



/**
* | output |
* | --- |
* | "Go to next event" |
*
* @param {Video_Export_Preview_Go_To_Next_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_go_to_next_title = /** @type {((inputs?: Video_Export_Preview_Go_To_Next_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Go_To_Next_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum nächsten Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai al prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к следующему мероприятию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往下一个活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントへ進む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले कार्यक्रम पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o próximo evento")
	return /** @type {LocalizedString} */ ("Go to next event")
});